import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_FBP_CLAIMS);

const _pk_name = "id";

const state = {
    data: [],
    employeeData: {},
    isFetching: false,
    isSaving: false,
    isDeleting: false
};
const getters = {

}
const mutations = {
    set: (state, payload) => {
        state.data = payload;
        //console.log('fetched data', state.data)
    },

    setEmployeeData: (state, payload) => {
        if (payload) {
            state.employeeData = payload;
        }
        //console.log('fetched exits', state.employeeData)
    },
    updateEmployeeFBPClaimsById: (state, payload) => {
        //console.log(payload);
    },
    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    setSaving: (state, payload) => {
        state.isSaving = payload;
    },

    setDeleting: (state, payload) => {
        state.isDeleting = payload;
    },
}

const actions = {
    async fetchAll({ commit }, payload) {
        //console.log("[state/payroll/settlefbpclaimsemployeepage/fetchAll] Calling API...",payload);
        try {
            commit("setFetching", true);
            let res = await axios_instance.get(``, {
                params: {
                    employeeId: payload
                  }
              });

            commit("setFetching", false);
            //console.log("[state/payroll/settlefbpclaimsemployeepage/fetchAll] res: ", res);
            if (res.status == 200) {
                commit("set", res.data.payload.data);
            }
            return res;
        } catch(error) {
            //console.log('error', error.response);
            throw errorHandler(error.response);
        }
    },

    async fetchFBPClaims({ commit }, payload) {
        //console.log("[state/payroll/settle_fbp_claims/fetchfbpclaims] Calling API...");
        //console.log('payload paygroup id', payload)
        try {
            commit("setFetching", true);
            let res = await axios_instance.post(`/`, {
                params: {
                    paygroupId: payload
                }
            });
            commit("setFetching", false);
            //console.log("[state/payroll/settle_fbp_claims/fetchfbpclaims] res: ", res);
            if (res.status == 200) {
                commit("setEmployeeData", res.data.rows);
            }
            return res;
        } catch(error) {
            //console.log('error', error.response);
            throw errorHandler(error.response);
        }
    },

    async updateFBPClaims({ commit }, payload) {
        //console.log("[state/payroll/settle_fbp_claims/update] Updating... Display payload", payload);
        try {
            commit("setSaving", true);
            let res = await axios_instance.put(`/${payload.id}`, payload);
            commit("setSaving", false);
            //console.log("[state/payroll/settle_fbp_claims/update] res: ", res);
            if (res.status == 200) {
                commit("updateEmployeeFBPClaimsById", res.data);
            }
            return res;
        } catch(error) {
            //console.log('error', error.response);
            throw errorHandler(error.response);
        }
    },

}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}